import axios from "axios";
import API_URL from "../config/config";
import { normalizePriceManipulation } from "./orderFlow";
import { getCachedPageData, setCachedPageData } from "./pageDataCache";

const PRICE_CONFIGURATION_CACHE_KEY = "price-configuration";

let priceConfigurationRequest = null;

export const getCachedPriceConfiguration = () =>
  getCachedPageData(PRICE_CONFIGURATION_CACHE_KEY);

export const preloadPriceConfiguration = () => {
  const cachedConfiguration = getCachedPriceConfiguration();
  if (cachedConfiguration) {
    return Promise.resolve(cachedConfiguration);
  }

  if (!priceConfigurationRequest) {
    priceConfigurationRequest = axios
      .get(`${API_URL}/price/get`)
      .then((response) => {
        const configuration = normalizePriceManipulation(
          response.data?.priceManipulation || {}
        );
        setCachedPageData(PRICE_CONFIGURATION_CACHE_KEY, configuration);
        return configuration;
      })
      .finally(() => {
        priceConfigurationRequest = null;
      });
  }

  return priceConfigurationRequest;
};

// These pages are loaded with the application bundle, so start retrieving
// their shared card data before a customer opens either order screen.
void preloadPriceConfiguration().catch(() => {});
